// Date interface
export interface BookingDate {
  _id: string;
  date: string;
  month: number;
  year: number;
  is_active: boolean;
  is_holiday: boolean;
}

// Pricing interface
export interface Pricing {
  _id: string;
  price: number;
}

// Consultant interface
export interface Consultant {
  _id: string;
  first_name: string;
  last_name: string;
  email: string;
  is_active: boolean;
}

// Slot interface
export interface Slot {
  _id: string;
  time_string: string;
  time: string;
  duration: number;
  is_active: boolean;
  pricing: Pricing;
  consultants: SlotConsultant[];
}

// Slot-Consultant mapping interface
export interface SlotConsultant {
  _id: string;
  first_name: string;
  is_active: boolean;
  slotConsultantMappingId: string;
  is_booked: boolean;
  on_hold: boolean;
  booked_by_google_calender: boolean;
}

// Session interface
export interface Session {
  _id: string;
  start_time: string;
  end_time: string;
  slot_consultant_mapping_id: string;
  price: number;
}

// Booking form data interface
export interface BookingFormData {
  first_name: string;
  last_name: string;
  email: string;
  contact_no: string;
  appointment_type: string;
  meeting_type: 'online' | 'offline';
  session_id: string;
  card_details: {
    card_number: string;
    exp_month: string;
    exp_year: string;
    cvv: string;
  };
}

// API response interfaces
export interface ApiResponse<T> {
  message: string;
  data: T;
}

// Appointment interface
export interface Appointment {
  _id: string;
  consultant_id: string;
  slot_id: string;
  date_id: string;
  slot_consultant_mapping_id: string;
  is_canceled: boolean;
  first_name: string;
  last_name: string;
  email: string;
  contact_no: string;
  appointment_type: string;
  meeting_type?: string;
  meeting_data?: any;
  createdAt: string;
  updatedAt: string;
}

// Appointment type options
export const APPOINTMENT_TYPES = [
  'Immigration Consultation',
  'Study Permit Application',
  'Work Permit Application',
  'Permanent Residence Application',
  'Citizenship Application',
  'Refugee Claim',
] as const;

export type AppointmentType = typeof APPOINTMENT_TYPES[number];

// Custom payment interfaces
export interface CustomPaymentFormData {
  first_name: string;
  last_name: string;
  email: string;
  contact_no: string;
  amount: number;
  file_number: string;
  additional_info: string;
  card_details: {
    card_number: string;
    exp_month: string;
    exp_year: string;
    cvv: string;
  };
}

export interface CustomPayment {
  _id: string;
  first_name: string;
  last_name: string;
  email: string;
  contact_no: string;
  amount: number;
  file_number: string;
  additional_info: string;
  payment_charge_id: string;
  price: number;
  payment_data: any;
  createdAt: string;
  updatedAt: string;
  is_payment_refunded: boolean;
  refund_data?: any;
}
